'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import SvgTabMoreLeft from '@common/icon/SvgTabMoreLeft';
import SvgTabMoreRight from '@common/icon/SvgTabMoreRight';
import { cn } from '@core/utils';
import useEmblaCarousel from 'embla-carousel-react';
import { BREAKPOINTS } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { GTM_EVENT_TYPE, trackGtmEvent } from '@/utils/analytics/gtm';
import { PickedGift } from './PickedGift';
import type { WelloPickItem } from './WelloPickSectionServer';
interface WelloPickSectionProps {
  items: WelloPickItem[];
  className?: string;
}
export const WelloPickSection = t0 => {
  const $ = _c(34);
  const {
    items,
    className
  } = t0;
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP);
  const t1 = items.length > 1;
  const t2 = isDesktopViewport ? false : true;
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = {
      loop: t1,
      align: "start",
      dragFree: t2
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t3);
  const handleClickItem = _temp;
  const isNotRender = items.length < 1;
  if (isNotRender) {
    return null;
  }
  let t4;
  if ($[3] !== className) {
    t4 = cn("flex flex-col items-center gap-24 px-40 content-container", "mobile-tablet:items-start mobile-tablet:gap-16 mobile-tablet:px-0", className);
    $[3] = className;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <header className={cn("flex items-center gap-8", "mobile-tablet:gap-4 mobile-tablet:px-20")}><h2 className={cn("font-700 text-Gray-900 typo-h4", "mobile-tablet:typo-body1")}>지금 많이 조회하는 답례품</h2></header>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = cn("w-fit max-w-full overflow-hidden", "mobile-tablet:px-20");
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== items) {
    let t8;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = (item_0, index) => <div key={item_0.productNumber} className="mr-12 !w-fit flex-[0_0_auto]"><PickedGift donationAmount={item_0.donationAmount} onClickItem={() => handleClickItem(item_0)} isDisplayInstitution={!!item_0.institutionName} imageUrl={item_0.imageUrl} institutionName={item_0.institutionName} isNew={item_0.isNew} readCount={item_0.readCount} productNumber={item_0.productNumber} slugId={item_0.slugId} productName={item_0.productName} reviewRating={item_0.reviewRating} reviewCount={item_0.reviewCount} priority={index === 0} /></div>;
      $[9] = t8;
    } else {
      t8 = $[9];
    }
    t7 = items.map(t8);
    $[7] = items;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[10] !== t7) {
    t8 = <div className="flex">{t7}</div>;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== emblaRef || $[13] !== t8) {
    t9 = <div ref={emblaRef} className={t6}>{t8}</div>;
    $[12] = emblaRef;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = cn("absolute -left-26 top-170 size-fit -translate-y-1/2 p-0", "mobile-tablet:hidden");
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== emblaApi) {
    t11 = () => emblaApi?.scrollPrev();
    $[16] = emblaApi;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <SvgTabMoreLeft className="size-52" originalFill={true} />;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t11) {
    t13 = <Button aria-label={"\uC774\uC804"} theme="sub-text" className={t10} onClick={t11}>{t12}</Button>;
    $[19] = t11;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = cn("absolute -right-26 top-170 size-fit -translate-y-1/2 p-0", "mobile-tablet:hidden");
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== emblaApi) {
    t15 = () => emblaApi?.scrollNext();
    $[22] = emblaApi;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <SvgTabMoreRight className="size-52" originalFill={true} />;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t15) {
    t17 = <Button aria-label={"\uB2E4\uC74C"} theme="sub-text" className={t14} onClick={t15}>{t16}</Button>;
    $[25] = t15;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t13 || $[28] !== t17 || $[29] !== t9) {
    t18 = <div className="relative w-fit max-w-full">{t9}{t13}{t17}</div>;
    $[27] = t13;
    $[28] = t17;
    $[29] = t9;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== t18 || $[32] !== t4) {
    t19 = <section className={t4}>{t5}{t18}</section>;
    $[31] = t18;
    $[32] = t4;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  return t19;
};
function _temp(item) {
  trackGtmEvent(GTM_EVENT_TYPE.SELECT_ITEM, {
    currency: "KRW",
    value: item.donationAmount,
    local_name: item.institutionName,
    items: [{
      item_type: "\uB2F5\uB840\uD488",
      item_list_name: "\uD648 \uC624\uB298\uC758 \uC6F0\uB85C Pick \uC139\uC158",
      item_list_id: item.productNumber,
      price: item.donationAmount,
      item_name: item.productName,
      quantity: 1,
      item_id: item.productNumber
    }]
  });
}